<template>
  <div>
    <v-dialog v-model="show_modal" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="headline">Выбор сертификата</v-card-title>
        <v-card-text>
          <div class="mb-20">Пожалуйста, выберите сертификат для подписи.</div>
          <v-divider></v-divider>

          <v-radio-group v-model="index_certificate" column>
            <v-radio
              v-for="(item, index) in certs_for_modal"
              :key="index"
              :label="`${item.subjectSimpleName}, ${item.issuerSimpleName}, действительно с ${item.validFromText} по ${item.validToText}`"
              :value="index"
            ></v-radio>
          </v-radio-group>
          <a @click.prevent="showAllCerts">Показать все сертификаты</a>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeModal()">
            Закрыть
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="choiceCert()"
            :disabled="!index_certificate && index_certificate !== 0"
          >
            Выбрать
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPlagin" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="headline">Криптоплагин не обнаружен</v-card-title>
        <v-card-text>
          <div class="mb-20">
            Пожалуйста, установите КриптоПро ЭЦП Browser plug-in, затем обновите
            страницу.
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogPlagin = false">
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { signatureService } from '@/utils/signature/signatureService.js';
import { ErrorAlertModule } from '@/store/modules/errors';
import { ServicesModule } from '@/store/modules/services';
import {AuthModule} from "@/store/modules/auth";
import {compareFullName} from "@/utils/common";

const SignatureService = signatureService();

function formatDate(date) {
  var dd = date.getDate();
  if (dd < 10) dd = '0' + dd;
  var mm = date.getMonth() + 1;
  if (mm < 10) mm = '0' + mm;
  var yyyy = date.getFullYear();
  return dd + '.' + mm + '.' + yyyy;
}

export default {
  name: 'SignatureComponent',
  data() {
    return {
      show_modal: false,
      certs_for_modal: [],
      index_certificate: null,
      dialogPlagin: false,
    };
  },
  created() {
    ServicesModule.setFunctionRunSign(this.runSign);
  },
  methods: {
    choiceCert() {
      if (!this.index_certificate && this.index_certificate !== 0) return;
      this.$emit('goodCert', this.index_certificate);
    },

    closeModal() {
      this.$emit('closeModal');
    },

    showAllCerts() {
      SignatureService.getCertificates()
        .then((data) => {
          // проверяем на существование плагина
          if (data && data.dialogPlagin) {
            this.dialogPlagin = true;
            throw new Error();
          } else if (data.error) {
            throw new Error(data.error);
          } else {
            return data;
          }
        })
        .then((certs) => {
          // приводим дату сертификата к читаемому виду
          this.certs_for_modal = certs
            .map((item) => {
              const from = new Date(item.validFrom);
              const to = new Date(item.validTo);
              return {
                ...item,
                validFrom: from,
                validTo: to,
                validFromText: formatDate(from),
                validToText: formatDate(to),
              };
            })
            // Проверка срока действия сертификата
            .filter(
              (item) => {
                return item.validTo > new Date()
                  && item.validFrom < new Date()
              }
            );
        })
    },

    async runSign(dataSigns, dataUserCertificate) {
      ErrorAlertModule.setErrorAlert('');
      var contentToSign = dataSigns;
      var signs = [];
      var names = [];
      for (var s in contentToSign) {
        if (contentToSign.hasOwnProperty(s)) {
          names.push(s);
          signs.push(contentToSign[s]);
        }
      }
      const user = await AuthModule.getPerson()
      const snils = user.snils.replace(/\D/g, '')
      return SignatureService.getSign(signs)
        .then((data) => {
          // проверяем на существование плагина
          if (data && data.dialogPlagin) {
            this.dialogPlagin = true;
            throw new Error();
          } else if (data.error) {
            throw new Error(data.error);
          } else {
            return data;
          }
        })
        .then((certs) => {
          // приводим дату сертификата к читаемому виду
          this.certs_for_modal = certs
            .map((item) => {
              const from = new Date(item.validFrom);
              const to = new Date(item.validTo);
              return {
                ...item,
                validFrom: from,
                validTo: to,
                validFromText: formatDate(from),
                validToText: formatDate(to),
              };
            })
            // Проверка срока действия сертификата
            .filter(
                (item) => {
                  const paramsArr = item.subjectDescription.split(',').filter((item) => item.includes('СНИЛС'))
                  if (paramsArr.length === 0) {
                    return false
                  }
                  const sertSnils = paramsArr[0].split('=')[1]
                  return item.validTo > new Date()
                  && item.validFrom < new Date()
                  && sertSnils === snils
                }
            );

          // вызываем модальное окно
          return new Promise((resolve, reject) => {
            this.show_modal = true;
            this.index_certificate = null;
            // выбранный сертификат
            this.$once('goodCert', (index_certificate) => {
              resolve(index_certificate);
            });
            // закрываем модалку
            this.$once('closeModal', () => {
              this.show_modal = false;
              reject({ message: 'Действие отменено пользователем' });
            });
          });
        })
        .then((index_certificate) => {
          this.show_modal = false;
          // Needed because sometimes in Opera to this moment (possibly because of new execution flow) certificate store becomes object with all properties undefined
          const index_certificate_int = parseInt(index_certificate);
          const certificate = this.certs_for_modal[index_certificate_int];
          // делаешь что то дальше после того как отработает модалка

          // Сам процесс подписания
          return SignatureService.startSigning(
            certificate,
            dataUserCertificate,
            signs
          );
        })
        .then((data) => {
          try {
            if (!data || !data.success) throw { message: data.message };
            var dataSend = {
              signs: {},
            };
            var nm;
            let arrSign = data.arrSign;
            for (var i = 0; i < names.length; i++) {
              for (var j = 0; j < arrSign.length; j++) {
                nm = names[i];
                if (j > 0) nm = nm + '.' + j;
                dataSend.signs[nm] = arrSign[j];
              }
            }

            // Отдать на бэкенд подпись
            return dataSend.signs;
          } catch (error) {
            throw new Error(error.message);
          }
        })
        .catch((error) => {
          let errorText = '';
          if (typeof error === 'string') {
            errorText = error;
          }
          if (error && error.message) {
            errorText = error.message;
          }
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            errorText = error.response.data.message;
          }
          ErrorAlertModule.setErrorAlert(errorText);
          // console.log('%c' + errorText, 'color: #ff2400');
          throw new Error();
        });
    },
  },
};
</script>

<style scoped lang="scss">
.mb-20 {
  margin-bottom: 20px;
}
</style>
